import { render, staticRenderFns } from "./CommonEventList.vue?vue&type=template&id=181b8dda&scoped=true&"
import script from "./CommonEventList.vue?vue&type=script&lang=js&"
export * from "./CommonEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b8dda",
  null
  
)

export default component.exports